module.exports = __webpack_public_path__ + "static/media/arrow-down.4cb3515a.svg";